import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'vendorSection.title',
    defaultMessage: 'Your provider',
  },
  name: {
    id: 'vendorSection.name',
    defaultMessage: 'Meet {name}',
  },
});
